import { analyticsUrl } from 'utils/wrappers';

import PageableBase, { PAGING_TYPES } from 'app/collections/pageable_base';
import TrackingAnalytic from 'app/models/tracking_analytic';

export default PageableBase.extend({
  model: TrackingAnalytic,
  key: 'processed_by_facilities',
  url: analyticsUrl('tracking/v2/facilities/processed'),
  pagingType: PAGING_TYPES.PER_PAGE,

  parseRecords(attrs) {
    const attributes = PageableBase.prototype.parseRecords.call(this, attrs);
    return attributes[0].countries[0].states.reduce((a, b) => a.concat(b.postal_codes), []);
  },

  additionalParamsForFetch() {
    return {
      relative: true,
      country: 'US',
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/tracking_analytics.js